import { DISCOUNT_URL } from '../constants';
import { apiSlice } from './apiSlice';

export const discountApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDiscount: builder.query({
      query: () => DISCOUNT_URL,
      providesTags: ['Discount'],
      keepUnusedDataFor: 30,
    }),
    updateDiscount: builder.mutation({
      query: (data) => ({
        url: DISCOUNT_URL,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['Discount'],
    }),
  }),
});

export const { useGetDiscountQuery, useUpdateDiscountMutation } = discountApiSlice;
